import { useNavigate } from '@tanstack/react-router';
import { UserStatus } from '../../services/api';
import HeaderActions from './HeaderActions';
import './Header.css';

interface HeaderProps {
    userStatus: UserStatus | null;
    onShowLogin: () => void;
}

export default function StandardHeader({ userStatus, onShowLogin }: HeaderProps) {
    const navigate = useNavigate();

    return (
        <header className="header">
            <nav className="nav">
                <div className="logo" onClick={() => navigate({ to: '/' })} style={{ cursor: 'pointer' }}>
                    <div className="logo-image-wrapper">
                        <img src="/raisa.png" alt="Raisa AI" className="logo-image" />
                    </div>
                    <span className="logo-text">Raisa<span>.</span></span>
                </div>
                <HeaderActions
                    userStatus={userStatus}
                    onShowLogin={onShowLogin}
                />
            </nav>
        </header>
    );
}
